import { lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';
import Arrow from './redesign/Arrow';
import AgentSpaceFallback from './redesign/AgentSpaceFallback';
const AgentSpace = lazy(() => import('./redesign/AgentSpace'));
export default function HeroSection() {
  return <section className="hero hero-agent-space hero-original-copy" aria-labelledby="hero-heading">
    <div className="hero-space-background">
      <Suspense fallback={<AgentSpaceFallback />}><AgentSpace /></Suspense>
    </div>
    <div className="hero-copy">
      <h1 id="hero-heading" className="hero-heading"><span className="hero-line"><span className="blue-type">AI &</span></span><span className="hero-line">Creative</span><span className="hero-line">Engineering<span className="blue-type">.</span></span></h1>
      <div className="hero-japanese"><h2>AIで、次のあたりまえを。</h2><p>AIエージェント、生成AI、映像解析。<br />構想から開発、運用、技術者の育成まで。<br />技術を、事業の力に。</p></div>
      <Link to="/service" className="text-link hero-link">私たちにできること <Arrow /></Link>
    </div>
    <div className="hero-bottom"><a href="#products" className="scroll-link">サービスを見る <span aria-hidden="true">↓</span></a></div>
  </section>;
}
